import React from 'react';
import "./styles.css";
/**
 * @function RightColumnContainer 
 * @param {STRING} className - class to add styles to the right column
 * @param {React.Component} children - React components or content that's being wrapped by the right column container.
 * @returns {React.Component}
 * @example
 * <RightColumnContainer>
 *  - Child elements goes here
 * </RightColumnContainer>
 */
export default function RightColumnContainer(props) {
  const className = props.className ?? "";
  return (
    <div className={className + " right-column-container column side-bar set-width flex-container flex-vertical"}>
      {props.children}
    </div>
  );
}